import MarketingContentPage from "@/components/marketing/MarketingContentPage"

export default function Careers() {
  return <MarketingContentPage pageKey="careers" seoKey="careers" />
}
